import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Badge,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  School as MyCoursesIcon,
  Search as SearchCoursesIcon,
  Chat as ChatIcon,
  KeyboardArrowUp as ArrowUpIcon,
} from "@mui/icons-material";
import { useQuery } from "@apollo/client";
import { GET_TOTAL_UNREAD_MESSAGES_COUNT } from "../small-course-nav/getTotalUnreadMessagesCountQuery";

export const MobileCourseNav = ({
  toggleMyCourses,
  toggleSearchCourses,
  toggleMobileChat,
}) => {
  const { data: userData } = useQuery(GET_TOTAL_UNREAD_MESSAGES_COUNT);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const unreadCount = userData?.user?.unreadMessagesCount || 0;

  if (!isMobile) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        display: { xs: 'block', md: 'none' },
      }}
    >
      <BottomNavigation
        sx={{
          backgroundColor: 'white',
          boxShadow: '0px -1px 4px rgba(0, 0, 0, 0.15)',
          '& .MuiBottomNavigationAction-root': {
            color: '#dddddd',
            '&.Mui-selected': {
              color: '#383838',
            },
          },
        }}
        showLabels
      >
        <BottomNavigationAction
          label="My Courses"
          icon={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <MyCoursesIcon />
            </Box>
          }
          onClick={toggleMyCourses}
        />
        
        <BottomNavigationAction
          label="Search"
          icon={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <SearchCoursesIcon />
            </Box>
          }
          onClick={toggleSearchCourses}
        />
        
        <BottomNavigationAction
          label="Chat"
          icon={
            <Badge
              badgeContent={unreadCount > 99 ? '+99' : unreadCount}
              color="error"
              invisible={unreadCount === 0}
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.7em',
                  height: 20,
                  minWidth: 20,
                },
              }}
            >
              <ChatIcon />
            </Badge>
          }
          onClick={toggleMobileChat}
        />
      </BottomNavigation>
    </Box>
  );
};

